import React from "react";
import TabSelector from "globalComponents/TabSelector/TabSelector";

export default function ListTypeSelector({ listType, setListType }) {
  const options = ["Plan", "Act", "Done"];
  return (
    <TabSelector
      options={options}
      shape="round"
      optionContents={options}
      selectedOption={listType}
      setSelectedOption={setListType}
    />
  );
}
